import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../stores/authStore';
import { hasPageAccess } from '../../constants/permissions';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);
  const pagePermissions = useAuthStore((s) => s.pagePermissions);
  const alarmRoleFilter = useAuthStore((s) => s.alarmRoleFilter);
  const permissionsLoaded = useAuthStore((s) => s.permissionsLoaded);
  const location = useLocation();

  if (!token) return <Navigate to="/login" replace />;

  // 不阻擋 UI：權限未載入時以 DEFAULT_PAGE_MIN_LEVEL 預設值放行
  // fetchPermissions 完成後 React 自動重新渲染並套用 DB 權限設定
  // （避免手機 pull-to-refresh 時卡在 Spinner 等 API 回應）
  if (user && permissionsLoaded && !hasPageAccess(location.pathname, user.role_level, user.role, pagePermissions, alarmRoleFilter)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
